module.exports = __webpack_public_path__ + "static/media/snoopyclearsky04.ce4ce30e.gif";